const config = {
  BACKEND_HOST: "http://144.48.104.132:6969",
};

export default config;
